<template>
  <div>
    <b-row class="border-bottom mb-2">
      <b-col>
        <h4 class="mb-0">
          Place objects at Site
        </h4>
        <small class="text-muted">
          Don't have any objects in the workspace yet? Do not worry, you can later assign objects to the site
        </small>
      </b-col>
    </b-row>
    <div>
      <b-form
        ref="form"
        :style="{height: trHeight}"
        class="repeater-form"
        style="overflow: visible"
        @submit.prevent="repeateAgain"
      >

        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in items"
          :id="item.id"
          :key="item.id"
          ref="row"
        >

          <!-- Item Name -->
          <b-col md="4">
            <b-form-group
              label="Object Name"
              label-for="item-name"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="objects"
                :clearable="false"
                @input="setSelected"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="2"
            md="3"
            class="mb-50"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Delete</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>

      </b-form>
    </div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="repeateAgain"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-25"
      />
      <span>Add Object</span>
    </b-button>
  </div>

</template>

<script>
import {
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,

    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    objects: {
      type: Array,
      required: true,
    },
    newSite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      nextTodoId: 2,
    }
  },
  watch: {
    newSite: {
      deep: true,
      handler(newVal) {
        this.newObject = newVal
      },
    },
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      if (this.newSite.objects.length > index) {
        this.objects.push(this.newSite.objects[index])
        this.newSite.objects.splice(index, 1)
      }
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    setSelected(value) {
      // Om den jag väljer inte existerar i selected device bytt plats på listan
      if (this.newSite.objects.length > 0 && !this.newSite.objects.includes(value) && !this.objects.includes(value)) {
        this.objects = this.newSite.objects
        this.objects = this.objects.filter(device => device.id !== value.id)
        this.newSite.objects = this.newSite.objects.filter(device => !this.objects.includes(device))
      } else {
        this.objects = this.objects.filter(device => device.id !== value.id)
      }
      this.newSite.objects.push(value)
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {

  transition: .35s height;
}
</style>
